import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import moment from "moment";

import "assets/scss/material-dashboard-pro-react/plugins/_plugin-react-datepicker.css";
import styles from "assets/jss/material-dashboard-pro-react/views/buttonsStyle.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import DatePicker from "react-datepicker";
import Username from "components/CustomInput/Username.js";
import "react-datepicker/dist/react-datepicker.css";

// react component for creating dynamic tables
// @material-ui/core components
import FormControlLabel from "@material-ui/core/FormControlLabel";
import SweetAlert from "react-bootstrap-sweetalert";

import Radio from "@material-ui/core/Radio";

import FiberManualRecord from "@material-ui/icons/FiberManualRecord";

// import { makeStyles } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CardAvatar from "components/Card/CardAvatar.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import EditProfileCard from "view2/EditProfileCard.jsx";
import ProfilePreview from "view2/ProfilePreview.jsx";
import CardFooter from "components/Card/CardFooter.js";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";
import updateUser from "api/user/updateUser";
import updateUsername from "api/user/updateUsername";
import { useTranslation } from "react-i18next";
const useStyles = makeStyles(styles);

// Object.assign(styles, {
//   cardIconTitle: {
//     ...cardTitle,
//     marginTop: "15px",
//     marginBottom: "0px"
//   },
//   restaurantName: {
//     textAlign: "center"
//   }
// });

export default function UserData(props) {
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  console.log(t);
  console.log(t("inputLabels.formattedAddress"));
  const user = props.user;
  // if (user && !user._id) {
  //   return null;
  // }
  // const [email, setEmail] = React.useState("");
  // const [password, setPassword] = React.useState("");
  console.log(user.userDataId);
  const [startDate, setStartDate] = useState(new Date());
  const [alert, setAlert] = useState(null);

  const [error, setError] = React.useState(false);
  return (
    <div className="main-banner-home">
      <GridContainer style={{ margin: "20px auto", maxWidth: "1200px" }}>
        <GridItem xs={12} md={8}>
          {user.userDataId ? (
            <EditProfileCard
              classes={classes}
              user={{
                description: user.userDataId.description || "",
                username: user.userDataId.username || "",
                firstName: user.userDataId.firstName || "",
                lastName: user.userDataId.lastName || "",
                middleName: user.userDataId.middleName || "",
                profileId: user.userDataId._id || "",
                gender: user.userDataId.gender || "other",
                birthDate: user.userDataId.birthDate || "",
                cityGeoname: user.userDataId.cityGeoname || {},
                idealCompany: user.userDataId.idealCompany || {},
                favouriteCuisine: user.userDataId.favouriteCuisine || {},
                favouritePlate: user.userDataId.favouritePlate || {}
              }}
              t={t}
              language={"it"}
              updateUser={e => {
                setAlert({
                  title: t("editProfile.saved_success_title"),
                  message: t("editProfile.saved_success_text"),
                  success: true
                });
                updateUser(e).then(() => {
                  const copyUser = { ...user };
                  const copyUserDataId = { ...copyUser.userDataId, ...e };
                  copyUser.userDataId = copyUserDataId;
                  if (e.username !== user.userDataId.username) {
                    return updateUsername({ username: e.username }).then(() => {
                      props.updateUser(copyUser);
                    });
                  }
                  props.updateUser(copyUser);
                });
              }}
              attributes={props.attributes}
            />
          ) : null}
        </GridItem>
        <GridItem xs={12} md={4} style={{ marginTop: "30px" }}>
          {user.userDataId ? (
            <ProfilePreview
              classes={classes}
              user={{
                description: user.userDataId.description || "",
                username: user.userDataId.username || "",
                firstName: user.userDataId.firstName || "",
                lastName: user.userDataId.lastName || "",
                middleName: user.userDataId.middleName || "",
                profileId: user.userDataId._id || "",
                profileImageUrl: user.userDataId.profileImageUrl || ""
              }}
              t={t}
              language={"it"}
              updateUser={e => {
                updateUser(e).then(() => {
                  const copyUser = { ...user };
                  const copyUserDataId = { ...copyUser.userDataId, ...e };
                  copyUser.userDataId = copyUserDataId;
                  if (e.username !== user.userDataId.username) {
                    return updateUsername({ username: e.username }).then(() => {
                      props.updateUser(copyUser);
                    });
                  }
                  props.updateUser(copyUser);
                });
              }}
              attributes={props.attributes}
            />
          ) : null}
        </GridItem>
      </GridContainer>
      {alert ? (
        <SweetAlert
          success={alert.success}
          // warning={!alert.success}
          style={{ display: "block", marginTop: "-100px", color: "black" }}
          title={t("editProfile.saved_success_title")}
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          confirmBtnCssClass={classes.button + " " + classes.success}
        >
          {t("editProfile.saved_success_text")}
        </SweetAlert>
      ) : null}
    </div>
    // </div>
  );
}
UserData.propTypes = {
  updateCity: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  updateUser: PropTypes.func.isRequired
};
